{
  "translation": {
    "button": {
      "ok": "OK",
      "cancel": "Absagen",
      "login": "Anmeldung",
      "logout": "Ausloggen",
      "save": "Speichern",
      "manageoptions": "Optionen verwalten",
      "manageproduct": "Produkt verwalten",
      "resetAll": "Alles auf Produktwerte zurücksetzen",
      "revert": "Zurückkehren",
      "statusButton": "Aktiv/Inaktiv",
      "add": "Hinzufügen",
      "selectCategory": "Kategorie auswählen",
      "close": "Schließen",
      "publish": "Veröffentlichen",
      "publishProductData": "An Sofon senden",
      "export": "Exportieren",
      "new": "Neu",
      "delete": "Löschen",
      "refresh": "Aktualisieren",
      "create": "Erstellen",
      "proCosExport": "ProCos Export",
      "pcsExport": "PCS Export",
      "submit": "Einreichen"
    },
    "tooltip": {
      "edit": "Bearbeiten",
      "view": "Sicht",
      "reset": "Zurücksetzen",
      "publishProductDataEnabled": "Im Rahmen des Masters vorhandene und veröffentlichte Daten werden weitergegeben.",
      "publishProductDataDisabled": "Deaktiviert, da das Produkt im Master inaktiv ist."
    },
    "footer": {
      "env": "Umschl",
      "release": "R",
      "sprint": "SP",
      "build": "Bauen",
      "branch": "Zweig",
      "date": "Datum"
    },
    "labels": {
      "selectCategoryType": "Wählen Sie einen Kategorietyp aus",
      "searchMultiNumericCategory": "Suche nach MultiNumericCategory",
      "addCategory": "Kategorie hinzufügen",
      "search": "Suchen",
      "recordsPerPage": "Aufzeichnungen",
      "workItem": "Arbeitsmittel",
      "searchproduct": "Produkt suchen",
      "language": "Sprache auswählen",
      "feature": "Besonderheit",
      "option": "Möglichkeit",
      "type": "Typ",
      "reset": "Zurücksetzen auf Produktwerte",
      "flag": "Flagge",
      "code": "Code",
      "country": "Land",
      "quote": "Anfrage",
      "saveStatus": "Speichern",
      "quoteSymbol": "Q",
      "expandAll": "Alles erweitern",
      "collapseAll": "Alles reduzieren",
      "masterProperties": "Master-Eigenschaften",
      "productProperties": "Produkteigenschaften",
      "categories": "Kategorien",
      "unassigned": "Nicht zugewiesen",
      "assigned": "Zugewiesen",
      "defaultAssignment": "Standardmäßig zugewiesen",
      "refresh": "Aktualisieren",
      "procos": "ProCoS",
      "pdm": "PDM",
      "product": "Produkt",
      "RuleCreationFailed": "Die gesamte Regelerstellung ist fehlgeschlagen",
      "standard": "Standard",
      "others": "Andere",
      "multiNumeric": "Multinumerisch",
      "multiNumericManagement": "MultiNumeric Verwaltung",
      "manage": "Verwalten",
      "yes": "Ja",
      "no": "Nein",
      "isActive": "Aktiv",
      "isLocal": "Ist lokal",
      "name": "Name",
      "multiNumericAction": "{{Action}} Multinumerische Funktion",
      "createdOn": "Erstellt am",
      "modifiedOn": "Geändert am",
      "createdBy": "Erstellt von",
      "modifiedBy": "Geändert von",
      "active": "Aktiv",
      "inActive": "Inaktiv",
      "propertyCode": "Eigenschafts-Code",
      "associationType": "Assoziationstyp",
      "featureCode": "Feature-Code",
      "optionCode": "Options-Code",
      "action": "Aktion",
      "oldValue": "Alter Wert",
      "newValue": "Neuer Wert",
      "startDate": "Startdatum",
      "endDate": "Enddatum",
      "history": "Verlauf",
      "properties": {
        "ACO": "Alternativer Code",
        "AGC": "Artikelgruppe",
        "ASC": "Zugehörige Codes",
        "CHT": "Kanaltyp",
        "CON": "Verbraucher",
        "DVI": "Lieferung per",
        "GRD": "Ist bewacht",
        "HDE": "Verstecken",
        "ICO": "Katalog nur für Kinder",
        "IPR": "Ist der Preis relevant",
        "ITY": "Artikeltyp",
        "MLE": "Maximale Länge",
        "OPT": "Ist optional",
        "ORI": "Bestellanweisungen",
        "PAT": "Produkttyp",
        "PCFD": "Drucken auf CFD",
        "PMA": "ProCos Marktverfügbarkeit",
        "RCI": "Veröffentlichungs-Katalogkennung",
        "REO": "Ist schreibgeschützt",
        "RMA": "Regeln Marktverfügbar",
        "RTY": "Referenztyp",
        "SCN": "SAP-Charakteristik-Name",
        "SCV": "SAP-Charakteristikwert",
        "SRI": "Ist der Service relevant?",
        "ERO": "Organisation der technischen Verantwortung"
      },
      "status": "Status",
      "columns": "Spalten",
      "filters": "Filter",
      "selectAll": "Alle auswählen",
      "consumers": "Verbraucher"
    },
    "home": {
      "header": "Auswahl des Produktmodells"
    },
    "dialogBox": {
      "error": "Fehler",
      "save": "Speichern",
      "reset": "Zurücksetzen",
      "revert": "Zurücksetzen",
      "unsavedChanges": "Warnung - nicht gespeicherte Änderungen",
      "delete10Items": "Es können jeweils nur 10 Datensätze gelöscht werden",
      "success": "Erfolg",
      "confirm": "Bestätigen {{action}}"
    },
    "messages": {
      "logoutMessage": "Der Benutzer ist abgemeldet. Bitte melden Sie sich erneut zur Anwendung an.",
      "unauthenticated": "Benutzer ist nicht angemeldet. Bitte melden Sie sich an. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an Ihren Administrator.",
      "browserNotSupported": "Browser nicht unterstützt",
      "browserNotSupportedMessage": "Sie verwenden einen Browser oder eine Browserversion, die nicht offiziell unterstützt wird.<1/><1/>Sie können die Anwendung weiterhin verwenden oder für ein optimales Erlebnis eine der neuesten Versionen des unterstützten Browsers verwenden.",
      "supportedBrowsers": "Unterstützte Browser: ",
      "errorTitle": "Fehler",
      "codeErrorMessage": "Bitte geben Sie einen gültigen Code ein",
      "nameErrorMessage": "Bitte geben Sie einen gültigen Namen ein",
      "downloadMessage": "{{filename}} wurde erfolgreich heruntergeladen",
      "noSearchRecords": "Keine Datensätze gefunden für '{{searchValue}}'",
      "noDataFound": "Keine Daten gefunden.",
      "noDataFoundForCriteria": "Keine Daten für die angegebenen Kriterien verfügbar.",
      "pdm": {
        "noPropertiesFound": "Keine Eigenschaften gefunden",
        "noPropertyAssociationFound": "Keine Eigenschaftszuordnungen gefunden."
      },
      "feature": {
        "confirmDelete": "Sind Sie sicher, dass Sie löschen möchten?"
      },
      "category": {
        "selectCategory": "Bitte wählen Sie eine Kategorie aus",
        "categoryAlreadyExist": "Sequenz oder Kategorie existiert bereits",
        "confirm": "Bestätigen",
        "confirmDelete": "Sind Sie sicher, dass Sie die Kategorie löschen möchten?",
        "confirmCleanEmptySection": "Abschnitte ohne Funktion werden entfernt.",
        "unsavedChanges": "Warnung - nicht gespeicherte Änderungen",
        "discardChanges": "Nicht gespeicherte Änderungen werden verworfen. Möchten Sie fortfahren?",
        "savedSuccessfully": "Masteransicht erfolgreich gespeichert",
        "noFeatureAssigned": "Es ist kein Feature zugewiesen !",
        "saveToremoveObsoleteFeature": "Es gibt veraltete Funktionen und er muss sparen",
        "multiNumericWarning": "Es können nur numerische Feature-Familien hinzugefügt werden.",
        "multiNumericReadError": "Funktion nicht gefunden",
        "multiNumericMinValidationError": "Mindestens {{minLength}} Zeichen erforderlich",
        "multiNumericMaxValidationError": "Maximal {{maxLength}} Zeichen zulässig",
        "searchLimitWarning": "Es werden {{limit}}/{{total}} Ergebnisse angezeigt. Verfeinern Sie die Suchkriterien, um die Ergebnisse einzugrenzen",
        "inValidCategoryDrag": "Kann nicht an dieser Position abgelegt werden"
      },
      "error": {
        "403": "Sie haben keinen Zugriff. Bitte wenden Sie sich an den Administrator.",
        "ERR_NETWORK": "Netzwerkfehler: Anfrage konnte nicht verarbeitet werden, versuchen Sie erneut, die Daten zu speichern.",
        "WiInvalid": "Das ausgewählte Arbeitselement ist ungültig! Bitte wählen Sie ein anderes oder erstellen Sie ein neues Arbeitselement.",
        "invalidWorkItemId": "Ungültige workItemId: Muss eine Zahl >= 1 sein",
        "E_RUL_VAL_101": "ProCos-Daten nicht gefunden",
        "E_PRD_VAL_101": "Ungültige Verbraucher {{consumers}}",
        "fetchPropertyAssociations": "Ein Fehler ist aufgetreten. Eigenschaftszuordnungen können nicht abgerufen werden!"
      },
      "http": {
        "404": "Quelle nicht gefunden.",
        "401": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
        "500": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
        "204": "Es müssen keine Änderungen gespeichert werden.",
        "400": "Ungültige Daten.",
        "403": "Sie haben keinen Zugriff. Wenden Sie sich an den Administrator."
      },
      "submit": {
        "general": "Änderungen wurden erfolgreich gespeichert!",
        "new": "Möchten Sie ProCoS-Informationen unter Neues Arbeitselement speichern ?",
        "exist": "Möchten Sie ProCoS-Informationen im WorkItem speichern - {{workItemName}}  ?",
        "allMarketsRemoved": "Verwenden Sie das Dropdown-Menü 'Status', um das Produkt als inaktiv zu markieren.",
        "success": "Änderungen erfolgreich in WorkItem gespeichert - {{workItemName}} ",
        "error": "Speichern fehlgeschlagen !",
        "reset": "Möchten Sie die ProCos von Feature/Option mit ProCos auf Produktebene zurücksetzen?",
        "resetAll": "Möchten Sie die ProCos aller Funktionen/Optionen mit Produktebene ProCos zurücksetzen?",
        "revert": "Möchten Sie Ihre Änderungen am aktuellen Workitem rückgängig machen - {{workItemName}}  ?",
        "failedEffectivities": "Fehlgeschlagen (Aktiv / Inaktiv): Folgende Funktion / Optionen konnten nicht verarbeitet werden.",
        "AllEffectivityFailed": "Alle Gültigkeitsaktualisierungen sind fehlgeschlagen.",
        "RulesSaved": "Regeln erfolgreich gespeichert.",
        "EffectivitySaved": "Gültigkeit erfolgreich gespeichert.",
        "DeleteRequest": "Löschanforderung fehlgeschlagen",
        "DeleteRequestSuccess": "Erfolgreich gelöschte ({{length}}) multiNumerische Features : {{list}}"
      },
      "cancel": {
        "workitemWarning": "Sind Sie sicher, dass Sie zum Arbeitselement wechseln möchten - {{workItemName}}  ?",
        "homeWarning": "Sind Sie sicher, dass Sie von dieser Seite aus navigieren möchten?",
        "featureChangeWarning": "Möchten Sie wirklich zu einer anderen Funktion wechseln?",
        "undoPropAssociationWarning": "Sind Sie sicher, dass Sie Ihre Änderungen rückgängig machen möchten?"
      },
      "refresh": "Ihre aktuellen Änderungen gehen bei der Aktualisierung verloren. Möchten Sie fortfahren?",
      "inActiveProduct": {
        "header": "Inaktives Produkt",
        "message": "Es sind keine Änderungen der Marktassoziation zulässig"
      },
      "saveProcos": {
        "rulesFailedTopic": "Verarbeitung fehlgeschlagen",
        "rulesFailed": "Seite {{pageNo}} : {{rule}} Regeln <ruleIcon/>, {{property}} Eigenschaften <propertyIcon/>",
        "batchStatus": "Speichern ProCos - {{completedBatchesCount}} Batch(es) abgeschlossen von {{totalBatchCount}} Batch(es).",
        "batchSuccess": "Alle Batch(es) erfolgreich",
        "batchFailed": "Alle Batch(es) fehlgeschlagen",
        "batchPartialSuccess": "Ein oder mehrere Stapel sind fehlgeschlagen"
      },
      "success": {
        "create": "Erfolgreich erstellt!",
        "update": "Erfolgreich aktualisiert!"
      },
      "fail": {
        "create": "Erstellung fehlgeschlagen!",
        "update": "Aktualisierung fehlgeschlagen!",
        "get": "Es ist ein Fehler aufgetreten. Details konnten nicht abgerufen werden!"
      },
      "validation": {
        "enumInvalid": "Ein oder mehrere Eigenschaftswerte sind ungültig (rot hervorgehoben). Bitte korrigieren Sie diese vor dem Speichern."
      }
    },
    "request": {
      "success": "Anfrage erfolgreich gestellt",
      "failed": "Die Anfrage ist fehlgeschlagen"
    }
  }
}
